import { useRef, useState } from 'react'

import { Grid, InputAdornment } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useEffectOnce } from 'react-use'
import { interfaces } from 'service/interfaces'

import useStyles from './styles'

export default function SearchNewOrder(props) {
  const { setDataForm, code, empresa, handleclose, dominio, stockId } = props

  const [loading, setLoading] = useState(false)

  const classes = useStyles()

  const refInput = useRef(null)

  const createDismissableSnackbar = useCustomSnackbar()

  useEffectOnce(() => {
    if (stockId) {
      handleSubmitStock(stockId)
    }
  })

  function handleRef() {
    refInput.current.click()
  }

  async function handleSubmitStock(values) {
    setLoading(true)

    const firstChar = typeof code === 'string' && code.length > 0 ? code.charAt(0) : null

    const empresaParam = firstChar === 'E' ? 1 : firstChar === 'O' ? 2 : empresa ? empresa : 3

    const usadoParam = ['U', 'R', 'N'].includes(firstChar) ? 1 : 0

    try {
      const res = await interfaces.plantOrders.searchStockOrVehicle(
        `?empresa=${empresaParam}&id=${values}&usado=${usadoParam}`
      )

      setDataForm({
        ...res.data,
        id: res?.data?.id ?? values,
        empresa: res.data.usado ? 1 : firstChar === 'E' ? 1 : firstChar === 'O' ? 2 : 3,
        codigo: code ?? null,
      })
    } catch (error) {
      createDismissableSnackbar(error.response?.data?.data, {
        variant: 'error',
      })

      if (code) {
        handleclose()
      }
    } finally {
      setLoading(false)
    }
  }

  function iconAdornment() {
    if (loading) {
      return (
        <InputAdornment position="end" className={classes.endAdornment}>
          <Divider className={classes.divider} orientation="vertical" />
          <CircularProgress
            style={{
              color: 'primary',
              width: '24px',
              height: '24px',
              marginLeft: '10px',
              marginRight: '10px',
            }}
          />
        </InputAdornment>
      )
    } else {
      return (
        <InputAdornment position="end" className={classes.endAdornment}>
          <Divider className={classes.divider} orientation="vertical" />
          <IconButton
            color="primary"
            className={classes.iconButton}
            onClick={() => handleRef()}
            disabled={true}
          >
            <ArrowRightAltIcon />
          </IconButton>
        </InputAdornment>
      )
    }
  }

  return (
    <Formik
      initialValues={{
        empresa: 3,
        dominio: dominio,
        id: stockId,
      }}
      onSubmit={(values) => handleSubmitStock(values)}
      className={classes.root}
      enableReinitialize
    >
      {({ values }) => (
        <Form>
          <Grid container>
            <Grid item sm={12} xs={12}>
              <Field
                component={TextField}
                name="id"
                fullWidth
                disabled
                className={classes.input}
                variant="outlined"
                value={values.dominio}
                InputProps={{
                  endAdornment: iconAdornment(),
                }}
              />
            </Grid>
          </Grid>
          <button style={{ display: 'none' }} ref={refInput} type="submit" />
        </Form>
      )}
    </Formik>
  )
}
